// extracted by mini-css-extract-plugin
export default {"hourColumn":"hours-column_hourColumn__tb9WT"};